import { connect } from 'react-redux'

export default (InnerComponent = null, action, empData) =>
  connect(() => ({ action, empData }))(InnerComponent)
